export default [
  { label: 'Pesos Chilenos', value: 'CLP' },
  { label: 'Unidad de fomento', value: 'UF' },
  { label: 'Dolar', value: 'USD' },
];
